module.exports = "/_next/static/images/e44667a6bd80dd144803276c3ce9fc74-cart-outline.svg";